module.exports = __webpack_public_path__ + "static/media/Eyes_2.89753de1.jpg";